<template>
  <div class="my-layout-box">
    <list-view
      :listMap="listMap"
      :getList="getList"
      :isTabsShow="isTabsShow"
      :isButtonShow="isButtonShow"
      :isSearchShow="isSearchShow">
    </list-view>
  </div>
</template>

<script>
import listView from "~/components/List/ListView.vue";
import { AddressData } from "./config";
import { getSupplierAddress } from "~/api/supplier";

export default {
  name: "receiverAddress",
  components: {
    listView
  },
  data() {
    return {
      isTabsShow: false,
      isButtonShow: false,
      isSearchShow: false,
      listMap: AddressData
    };
  },

  methods: {
    async getList(pagination, searchData) {
      let sendData = {
        page: pagination.page,
        limit: pagination.size
      };
      searchData.value = searchData.value;
      const list = await getSupplierAddress();
      const data = {
        List: list.Items,
        Total: list.Total
      };
      return data;
    }
  }
};
</script>

<style lang="less" scope></style>
